
export interface ICancellationToken {
    isCancelled(): boolean
}

class CancellationToken {

    //#region Mebers

    private cancelled: boolean;

    //#endregion


    //#region Ctor

    constructor() {
        this.cancelled = false;
    }

    //#endregion


    //#region ICancellationToken Implementation

    public isCancelled(): boolean {
        return this.cancelled;
    }

    //#endregion


    //#region Cancel

    public cancel(): void {
        this.cancelled = true;
    }

    //#endregion
}

export class CancellationTokenSource {

    //#region Properties

    private _token: CancellationToken
    public get token(): ICancellationToken {
        return this._token
    };

    //#endregion


    //#region Ctor

    constructor() {
        this._token = new CancellationToken();
    }

    //#endregion


    //#region Cancel

    public cancel(): void {
        this._token.cancel()
    }

    //#endregion

}